import { render } from "./PrintFooterDesign4.vue?vue&type=template&id=1ce291b6&scoped=true"
import script from "./PrintFooterDesign4.vue?vue&type=script&lang=js"
export * from "./PrintFooterDesign4.vue?vue&type=script&lang=js"

import "./PrintFooterDesign4.vue?vue&type=style&index=0&id=1ce291b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce291b6"]])

export default __exports__